export default {"src":"/login-app/[GIT_HASH]/_next/static/media/account_circle.512869a8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};